import { render, staticRenderFns } from "./verificateForm.vue?vue&type=template&id=09de3701&scoped=true&"
import script from "./verificateForm.vue?vue&type=script&lang=js&"
export * from "./verificateForm.vue?vue&type=script&lang=js&"
import style0 from "./verificateForm.vue?vue&type=style&index=0&id=09de3701&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de3701",
  null
  
)

export default component.exports